// extracted by mini-css-extract-plugin
module.exports = {"mainBlock":"NewPlaceRetread_mainBlock__37gFY","buttonsWrapper":"NewPlaceRetread_buttonsWrapper__2dswk"};